var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sys-user-table',{attrs:{"client-type":"admin","title":"Admin List","create-text":"New Admin","entity-name":"admin","show-roles":"","protect-built-in-admin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }